import {Input} from '@mintdata-wsp/common/components/input/Input';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {FunctionsMenu} from '@mintdata-wsp/wsp/ui/views/visualDesigner/spreadsheet/header/topFormulaEditor/FunctionsMenu';
import {TopFormulaEditorSeparator} from '@mintdata-wsp/wsp/ui/views/visualDesigner/spreadsheet/header/topFormulaEditor/TopFormulaEditorSeparator';
import {ValueFormatMenu} from '@mintdata-wsp/wsp/ui/views/visualDesigner/spreadsheet/header/topFormulaEditor/ValueFormatMenu';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const themeStyles = require('./TopFormulaEditor.less');
const cx = classnames.bind(themeStyles);

export interface IFormulaEditorProps
{

}

@observer
export class TopFormulaEditor extends React.Component<IFormulaEditorProps>
{
    public render():JSX.Element
    {
        const {topFormulaEditor} = controllers.ui.spreadsheets;

        return (
            <div className={cx('base')}>
                <FunctionsMenu/>
                <TopFormulaEditorSeparator/>
                <Input
                    isReadOnly
                    initialValue={topFormulaEditor.getActiveCellFormula()}
                    className={cx('input')}
                />
                <ValueFormatMenu/>
            </div>
        );
    }
}
